export const FORM_NAME_POSTFIX = '_form';
